import { axiosIns } from "../utils";
import { isLegacyCrmEnabled } from "../constants/featureFlags";

export const fetchCollaborators = async () => {
  if (!isLegacyCrmEnabled) return [];
  const res = await axiosIns.get("/collaborators/");
  return res && res.data ? res.data : res;
};

export const fetchCollaboratorById = async (id) => {
  if (!isLegacyCrmEnabled) return null;
  const res = await axiosIns.get(`/collaborators/${id}/`);
  return res && res.data ? res.data : res;
};

export const createCollaboratorApi = async (payload) => {
  if (!isLegacyCrmEnabled) {
    throw new Error("Le module collaborateurs est indisponible avec ce backend.");
  }
  const res = await axiosIns.post("/collaborators/", payload);
  return res && res.data ? res.data : res;
};

export const updateCollaboratorApi = async (id, payload) => {
  if (!isLegacyCrmEnabled) {
    throw new Error("Le module collaborateurs est indisponible avec ce backend.");
  }
  const res = await axiosIns.patch(`/collaborators/${id}/`, payload);
  return res && res.data ? res.data : res;
};

export const deleteCollaboratorApi = async (id) => {
  if (!isLegacyCrmEnabled) {
    throw new Error("Le module collaborateurs est indisponible avec ce backend.");
  }
  const res = await axiosIns.delete(`/collaborators/${id}/`);
  return res && res.data ? res.data : res;
};
